import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';

/**
 * Deterministic placeholder cover. It uses a familiar symbol instead of an
 * external image, so campaign cards have an identity without stored assets.
 */
@Component({
  selector: 're-story-sigil',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonIcon],
  template: `
    <span class="story-sigil" [class.story-sigil--muted]="isMuted()" aria-hidden="true">
      <ion-icon [name]="iconName()"></ion-icon>
    </span>
  `,
  styleUrl: './story-sigil.component.scss',
})
export class StorySigilComponent {
  storyId = input.required<number>();

  iconName = computed(() => {
    const icons = [
      'book-outline',
      'map-outline',
      'dice-outline',
      'globe-outline',
      'sparkles-outline',
    ];
    return icons[Math.abs(this.storyId()) % icons.length];
  });

  isMuted = computed(() => Math.abs(this.storyId()) % 2 === 0);
}
